// extracted by mini-css-extract-plugin
export default {"heading":"Targeting_heading__82qmx","wrapper":"Targeting_wrapper__hW5sf"};